import { Component } from '@angular/core';
import { MatIcon } from "@angular/material/icon";
import { MatDialogClose } from "@angular/material/dialog";

@Component({
  selector: 'app-dialog-access-denied',
  imports: [
    MatIcon,
    MatDialogClose
  ],
  templateUrl: './dialog-access-denied.component.html',
  styleUrl: './dialog-access-denied.component.scss'
})
export class DialogAccessDeniedComponent {

}
